import React, { useState, useRef } from "react";
import { ActionIcon, TextInput, Text } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  matchCount?: number;
}

export const PlanogramSearch = ({ value, onChange, matchCount }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const expand = () => {
    setExpanded(true);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const collapse = () => {
    setExpanded(false);
    onChange("");
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") collapse();
  };

  if (!expanded) {
    return (
      <div
        className="absolute top-2 left-2 z-20"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <ActionIcon
          variant="filled"
          color="gray"
          size="md"
          onClick={expand}
          title="Search products"
        >
          <IconSearch size={16} />
        </ActionIcon>
      </div>
    );
  }

  return (
    <div
      className="absolute top-2 left-2 z-20 flex items-center gap-1"
      onMouseDown={(e) => e.stopPropagation()}
    >
      <TextInput
        ref={inputRef}
        size="xs"
        placeholder="Search products…"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        style={{ width: 220 }}
        rightSection={
          value ? (
            <ActionIcon
              size="xs"
              variant="transparent"
              onClick={() => onChange("")}
            >
              <IconX size={12} />
            </ActionIcon>
          ) : null
        }
      />
      {value && matchCount !== undefined && (
        <Text size="xs" c="dimmed" style={{ whiteSpace: "nowrap" }}>
          {matchCount} match{matchCount !== 1 ? "es" : ""}
        </Text>
      )}
      <ActionIcon
        size="xs"
        variant="transparent"
        onClick={collapse}
        title="Close search"
      >
        <IconX size={14} />
      </ActionIcon>
    </div>
  );
};
